import ClearIcon from '@mui/icons-material/Clear';
import { InputLabel, MenuItem, FormControl, Select, Button } from '@mui/material';
import { ref, update, remove } from 'firebase/database';
import Cookies from 'js-cookie';
import { useState, useEffect, useRef } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import StudentGroupModal from './StudentGroupModal';
import { getStudents, getStudentsGroup, getTeachers } from '../../Common/Database';
import { database } from '../../Common/Firebase';
import Loader from '../../Components/Loader';
import NoItems from '../../Components/NoItems';
import ResetButton from '../../Components/ResetButton';
import Tooltipe from '../../Components/Tooltipe';
import { throwErrorRollbar } from '../../index';
import { setStudentNames } from '../../redux/slices/nameStudentsSlice';
import { getUserType } from '../../redux/slices/userSlice';

import './style.scss';

const { SearchBar } = Search;

const GroupsList = ({ mail }) => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userTypeSelector = useSelector(getUserType);
  const searchRef = useRef(null);

  const selectedFilterSubject = JSON.parse(Cookies.get('selectedFilterSubject') ?? '{}');

  const [studetnItems, setStudetnItems] = useState([]);
  const [studentsGroupItems, setStudentsGroupItems] = useState([]);
  const [unicSubject, setUnicSubject] = useState([]);
  const [studentActive, setStudentActive] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [student, setStudent] = useState([]);
  const [popupRemove, setPopupRemove] = useState(false);
  const [userType, setUserType] = useState(userTypeSelector);
  const [openGroupStudentsModal, setOpenGroupStudentsModal] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [listTeachers, setListTeachers] = useState([]);

  const [selectedSubject, setSelectedSubject] = useState(selectedFilterSubject.selectedSubject ?? '');

  const admins = userType === 'NewAdmin' || userType === 'Admin' || userType === 'Superadmin';

  const onStudentsGroupSubject = e => {
    selectedFilterSubject.selectedSubject = e.target.value;
    Cookies.set('selectedFilterSubject', JSON.stringify(selectedFilterSubject));
    setSelectedSubject(e.target.value);
  };

  const feachTeacher = async () => {
    await getTeachers().then(response => {
      const arrTeachers = Object.values(response);
      setListTeachers(arrTeachers);
      setIsLoading(false);
    });
  };

  const feachGroupListData = async () => {
    const studentsGroupList = await getStudentsGroup(selectedSubject);
    if (studentsGroupList) {
      let mapList = Object.values(studentsGroupList);

      if (userType === 'Teacher') {
        const filteredMapList = mapList.filter(student => {
          if (student.subjects && Object.keys(student.subjects).length > 0) {
            for (const subjectKey in student.subjects) {
              const subject = student.subjects[subjectKey];
              if (subject.attachedTeacher && subject.attachedTeacher.id === mail) {
                return true;
              }
            }
          }
          return false;
        });

        setStudentsGroupItems(filteredMapList);
      } else {
        setStudentsGroupItems(mapList);
      }
      setIsLoading(false);
    }
  };

  const filterStudentsList = (studentsGroupList, mail) => {
    const mapList = Object.values(studentsGroupList);
    const filteredMapList = mapList.filter(student => {
      if (student.subjects && Object.keys(student.subjects).length > 0) {
        for (const subjectKey in student.subjects) {
          const subject = student.subjects[subjectKey];
          if (subject.attachedTeacher && subject.attachedTeacher.id === mail) {
            return true;
          }
        }
      }
    });
    return filteredMapList;
  };

  const fetchSubject = async () => {
    const studentsGroupList = await getStudentsGroup();
    const filteredMapList = filterStudentsList(studentsGroupList, mail);

    if (userType === 'Teacher' && studetnItems) {
      const activeSubjects = filteredMapList
        .filter(item => {
          const subjects = item.subjects;
          if (subjects) {
            for (const subjectKey in subjects) {
              const subject = subjects[subjectKey];
              if (subject.activeSub === true) {
                return true;
              }
            }
          }
          return false;
        })
        .map(item => {
          const subjects = item.subjects;
          return Object.keys(subjects).filter(
            subjectKey =>
              subjects[subjectKey].activeSub === true &&
              subjects[subjectKey].attachedTeacher &&
              subjects[subjectKey].attachedTeacher.id === mail,
          );
        });

      const uniqArr = [...new Set(activeSubjects.flat())];
      uniqArr.sort((a, b) => a.localeCompare(b));
      setUnicSubject(uniqArr);
    }

    if (admins) {
      let mapList = studentsGroupList[0].subjects;
      const subjectsArr = [];
      for (let key in mapList) {
        subjectsArr.push(key);
      }
      setUnicSubject(subjectsArr);
    }
  };

  useEffect(() => {
    fetchStudentsListData();
    feachGroupListData();
    setUserType(userTypeSelector);
    fetchSubject();
    if (admins) {
      feachTeacher();
    }
  }, [selectedSubject, userTypeSelector, userType, selectedTeacher]);

  const fetchStudentsListData = async () => {
    const studentsGroupList = await getStudentsGroup();
    const filteredMapList = filterStudentsList(studentsGroupList, mail);
    const studentsList = await getStudents();
    if (studentsList) {
      let mapList = Object.values(studentsList);
      setStudetnItems(mapList);
      dispatch(setStudentNames(mapList));
      setIsLoading(false);
    }

    return filteredMapList;
  };

  const removeStudentsGroup = async () => {
    const stGroupId = localStorage.getItem('studentsGroupId');
    await remove(ref(database, `StudentsGroup/${stGroupId}`), {
      stGroupId,
    });
    localStorage.removeItem('studentsGroupId');
    feachGroupListData();
    setPopupRemove(false);
    setTimeout(() => {
      searchRef.current.props.onSearch('');
    }, 0);
  };

  const notRemoveStudentsGroup = () => {
    localStorage.removeItem('studentsGroupId');
    setPopupRemove(false);
  };

  const columns = admins
    ? [
        { dataField: 'id', hidden: true },
        {
          dataField: 'groupName',
          text: t('groupName'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('groupName') },
          sort: true,
        },
        {
          dataField: 'students',
          text: t('students'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('students') },
          formatter: students => {
            if (students && students.length > 0) {
              return (
                <>
                  {students.map((student, index) => (
                    <span className="student" key={index}>
                      {student.FIO}
                    </span>
                  ))}
                </>
              );
            } else {
              return '-';
            }
          },
        },
        {
          dataField: 'subjects',
          text: t('teachers'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('teachers') },
          formatter: subjects => {
            const subjArr = Object.values(subjects);
            const teachers = subjArr.map((item, index) => {
              if (item.attachedTeacher !== null && item.attachedTeacher !== undefined) {
                return (
                  <span className="student" key={index}>
                    {item.attachedTeacher.FIO}
                  </span>
                );
              }
              return null;
            });

            return teachers;
          },
        },
        {
          dataField: 'subjects',
          text: t('subjects'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('subjects') },
          formatter: subjects => {
            const subjArr = Object.values(subjects);

            const filterSubjects = subjArr.map((item, index) => {
              if (item.activeSub === true) {
                return (
                  <span className="student" key={index}>
                    {t(item.name)}
                  </span>
                );
              }
              return null;
            });

            return filterSubjects;
          },
        },
        {
          dataField: 'active',
          text: t('activation'),
          headerStyle: {
            width: '100px',
          },
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('activation') },
          formatter: dataField => {
            const buttonStyles = {
              background: dataField ? '#f2e6ed' : '#9cdffc',
            };

            return (
              <button id={String(dataField)} style={buttonStyles} className="btn btn-primary more btn-active">
                {dataField ? t('turnOff') : t('turnOn')}
              </button>
            );
          },
        },
        {
          dataField: 'id',
          text: <div className="sticky-wrap">{t('options')}</div>,
          attrs: { 'data-label': t('options') },
          headerStyle: {
            width: '50px',
          },
          formatter: dataField => (
            <div className="actions-wrap">
              <div className="btn-wrap">
                <Tooltipe text="view" icon="icon-preview" btnClass="move-view" />
                <Tooltipe text="delete" icon="icon-delete" btnClass="move-delete" />
              </div>
            </div>
          ),
        },
      ]
    : [
        { dataField: 'id', hidden: true },
        {
          dataField: 'groupName',
          text: t('groupName'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('groupName') },
          sort: true,
        },
        {
          dataField: 'students',
          text: t('students'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('students') },
          formatter: students => {
            if (students && students.length > 0) {
              return (
                <>
                  {students.map((student, index) => (
                    <span className="student" key={index}>
                      {student.FIO}
                    </span>
                  ))}
                </>
              );
            } else {
              return '-';
            }
          },
        },
        {
          dataField: 'subjects',
          text: t('teachers'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('teachers') },
          formatter: subjects => {
            const subjArr = Object.values(subjects);
            const teachers = subjArr.map((item, index) => {
              if (item.attachedTeacher !== null && item.attachedTeacher !== undefined) {
                return (
                  <span className="student" key={index}>
                    {item.attachedTeacher.FIO}
                  </span>
                );
              }
              return null;
            });

            return teachers;
          },
        },
        {
          dataField: 'subjects',
          text: t('subjects'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('subjects') },
          formatter: subjects => {
            const subjArr = Object.values(subjects);

            const filterSubjects = subjArr.map((item, index) => {
              if (item.activeSub === true) {
                return (
                  <span className="student" key={index}>
                    {t(item.name)}
                  </span>
                );
              }
              return null;
            });

            return filterSubjects;
          },
        },
        {
          dataField: 'id',
          text: <div className="sticky-wrap">{t('options')}</div>,
          attrs: { 'data-label': t('options') },
          headerStyle: {
            width: '50px',
          },
          formatter: dataField => (
            <div className="actions-wrap">
              <Tooltipe text="view" icon="icon-preview" btnClass="move-view" />
            </div>
          ),
        },
      ];

  const defaultSorted = [
    {
      dataField: 'groupName',
      order: 'asc',
    },
  ];

  const rowEvents = {
    onClick: async (e, row) => {
      const studentsGroupId = row.id;
      const stEmails = row.students.map(item => item.email);

      if (e.target.className === 'btn btn-icon move-view') {
        sessionStorage.setItem('StudentsGroupView', JSON.stringify(row));
        navigate(`/students-group-view/${studentsGroupId}`, {
          state: { fio: row.FIO, studentMail: row.email, stEmails: stEmails },
        });
      }

      if (e.target.className === 'btn btn-primary more btn-active') {
        setStudentActive(prev => !prev);
        stEmails.map(async email => {
          try {
            if (studentActive) {
              await update(ref(database, `Students/${email}`), {
                active: (row.active = true),
              });
            }
            if (!studentActive) {
              await update(ref(database, `Students/${email}`), {
                active: (row.active = false),
              });
            }
            feachGroupListData();
          } catch (error) {
            console.log(error);
            throwErrorRollbar(error);
          }
        });
      }

      if (e.target.className === 'btn btn-icon move-delete') {
        try {
          localStorage.setItem('studentsGroupId', studentsGroupId);
          setPopupRemove(true);
        } catch (error) {
          console.log(error);
          throwErrorRollbar(error);
        }
      }
    },
  };

  const pageSize = 10;

  const pagination = paginationFactory({
    sizePerPage: pageSize,
    hideSizePerPage: true,
    page: selectedFilterSubject.page,
    onPageChange: page => {
      selectedFilterSubject.page = page;
      Cookies.set('selectedFilterSubject', JSON.stringify(selectedFilterSubject));
    },
  });

  const openModalCreateGroupStudent = () => {
    setOpenGroupStudentsModal(true);
  };

  return (
    <>
      <ToolkitProvider key={i18n.language} keyField="email" data={studentsGroupItems} columns={columns} search>
        {props => (
          <div className="materials-page students-page student-group-page container">
            <ul className="filters-list first-list">
              <li>
                <FormControl fullWidth>
                  <InputLabel id="subject-hw-label">{t('subjectFilter')}</InputLabel>
                  <Select
                    labelId="subject-label"
                    id="subject-hw-select"
                    value={selectedSubject}
                    label={t('subjectFilter')}
                    onChange={onStudentsGroupSubject}
                    endAdornment={
                      selectedSubject && (
                        <ResetButton
                          onClick={() => {
                            setSelectedSubject('');
                            Cookies.set('selectedFilterSubject', JSON.stringify({}));
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </ResetButton>
                      )
                    }
                  >
                    {unicSubject
                      .sort((a, b) => t(a).localeCompare(t(b)))
                      .map((subject, i) => {
                        return (
                          <MenuItem key={i} value={subject}>
                            {t(subject)}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </li>

              <li className="search-input">
                <SearchBar {...props.searchProps} srText="" placeholder={t('search')} ref={searchRef} />
              </li>
              {admins && (
                <li>
                  <Button className="btn clear-filter with-icon" onClick={() => openModalCreateGroupStudent()}>
                    <span className="icon icon-plus"></span>
                    <span className="title">{t('Create a group of students')}</span>
                  </Button>
                </li>
              )}
            </ul>
            <hr />
            <div className="materials-table">
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  {studentsGroupItems && studentsGroupItems.length ? (
                    <BootstrapTable
                      {...props.baseProps}
                      pagination={studentsGroupItems.length > pageSize ? pagination : null}
                      rowEvents={rowEvents}
                      defaultSorted={defaultSorted}
                    />
                  ) : userType === 'Teacher' ? (
                    <NoItems titleNoItems={t('There are no added student groups yet. contact the administrator')} />
                  ) : (
                    <NoItems titleNoItems={t('There are no added student groups yet')} />
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </ToolkitProvider>

      {openGroupStudentsModal && (
        <StudentGroupModal
          open={openGroupStudentsModal}
          setOpen={setOpenGroupStudentsModal}
          student={student}
          studetnItems={studetnItems}
          feachGroupListData={feachGroupListData}
        />
      )}

      <div className={popupRemove ? 'popup-remove active' : 'popup-remove'}>
        <div className="popup-remove-content">
          <h3>{t('do you want delete students group?')}</h3>
          <div className="btn-wrap">
            <button className="btn btn-primary more btn-active" onClick={() => removeStudentsGroup()}>
              {t('yes')}
            </button>
            <button className="btn more btn-view" onClick={notRemoveStudentsGroup}>
              {t('no')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GroupsList;
